import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import _get from 'lodash/get';
import _head from 'lodash/head';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import { IMAGE_POSITION_TOP, FIRST_POSITIONS, INTERACTION_LABEL, INTERACTION_URL } from './Announcement.constants';
import { AnnouncementPropTypes } from './Announcement.proptypes';
import { shouldRenderHorizontalCard, shouldRenderBackgroundImage, shouldRenderSingleImage, shouldRenderImageCarousel, getAnnouncementContent, getCustomFormConfiguration, canSubmitForm, formatFieldsForEmailCapture, shouldRenderVerticalCard } from './Announcement.utils';
import MarkdownContent from '../../../../components/MarkdownContent';
import EmailCapture from '../../../../organisms/EmailCapture/EmailCapture';
import { classNames } from '../../../../utils/classname';
import { ANNOUNCEMENT_EVENT_CATEGORY, ANNOUNCEMENT_MODAL_BUTTON_CLICK_ACTION } from '../../../analytics/components/Event/Event.constants';
import ImageCard from '../../../images/components/ImageCard';
import WebsiteComponentInteraction from '../../../interactions/components/WebsiteComponentInteraction';
import { INTERACTION_DISPLAY_TYPE_ICON } from '../../../interactions/constants';
import { getClickthroughInteractions, getNonClickthroughInteractions } from '../../../interactions/utils';
import './Announcement.less';
var defaultProps = {
  id: null,
  images: [],
  contentNodes: [],
  interactions: [],
  childConfigurations: [],
  imagePosition: IMAGE_POSITION_TOP,
  children: null,
  className: '',
  locationId: null,
  businessId: null,
  businessType: null,
  parentInteraction: null
};
export default function Announcement(_ref) {
  var _classNames;
  var images = _ref.images,
    contentNodes = _ref.contentNodes,
    interactions = _ref.interactions,
    childConfigurations = _ref.childConfigurations,
    imagePosition = _ref.imagePosition,
    children = _ref.children,
    className = _ref.className,
    businessType = _ref.businessType,
    businessId = _ref.businessId,
    locationId = _ref.locationId,
    parentInteraction = _ref.parentInteraction;
  var finalClassName = classNames((_classNames = {
    announcement: true
  }, _defineProperty(_classNames, className, true), _defineProperty(_classNames, "horizontal", shouldRenderHorizontalCard(images, imagePosition)), _defineProperty(_classNames, "vertical", shouldRenderVerticalCard(images, imagePosition)), _defineProperty(_classNames, imagePosition, true), _defineProperty(_classNames, 'no-image', _isEmpty(images)), _classNames));
  if (!_isNil(children)) {
    return /*#__PURE__*/React.createElement(ImageCard, {
      className: finalClassName
    }, children);
  }
  var customFormConfiguration = getCustomFormConfiguration(childConfigurations);
  var nonClickthroughInteractions = getNonClickthroughInteractions(interactions);
  var clickthroughInteractions = getClickthroughInteractions(interactions);
  var mainClickthroughInteraction = _head(clickthroughInteractions);
  var interactionComponents = nonClickthroughInteractions.map(function (interaction) {
    return /*#__PURE__*/React.createElement(WebsiteComponentInteraction, {
      interaction: interaction,
      event: {
        category: ANNOUNCEMENT_EVENT_CATEGORY,
        action: ANNOUNCEMENT_MODAL_BUTTON_CLICK_ACTION,
        label: _get(interaction, INTERACTION_LABEL),
        value: _get(interaction, INTERACTION_URL)
      }
    });
  });
  var content = getAnnouncementContent(contentNodes);
  var formComponent = null;
  var _ref2 = customFormConfiguration || {},
    _ref2$data = _ref2.data,
    _ref2$data2 = _ref2$data === void 0 ? {} : _ref2$data,
    _ref2$data2$fields = _ref2$data2.fields,
    fields = _ref2$data2$fields === void 0 ? [] : _ref2$data2$fields,
    _ref2$data2$submitBut = _ref2$data2.submitButtonText,
    submitButtonText = _ref2$data2$submitBut === void 0 ? '' : _ref2$data2$submitBut,
    _ref2$data2$subscript = _ref2$data2.subscriptionTags,
    subscriptionTags = _ref2$data2$subscript === void 0 ? [] : _ref2$data2$subscript;
  if (!_isNil(customFormConfiguration) && !_isEmpty(fields) && canSubmitForm(businessType, businessId, locationId)) {
    var formattedFields = formatFieldsForEmailCapture(fields);
    formComponent = /*#__PURE__*/React.createElement(EmailCapture, {
      headerText: "",
      fields: formattedFields,
      type: "inline",
      button: {
        label: submitButtonText || 'Submit',
        primary: true
      },
      className: "announcement-form",
      businessId: businessId,
      businessType: businessType,
      locationId: locationId,
      tags: subscriptionTags
    });
  }
  var markdownContent = !content ? null : /*#__PURE__*/React.createElement(MarkdownContent, {
    content: content
  });
  var contentComponents = /*#__PURE__*/React.createElement(React.Fragment, null, markdownContent, !_isEmpty(interactionComponents) && interactionComponents, parentInteraction, formComponent);
  var imageCardComponents = !contentComponents ? null : /*#__PURE__*/React.createElement(ImageCard.Content, null, /*#__PURE__*/React.createElement("div", {
    className: "components"
  }, contentComponents));
  if (shouldRenderBackgroundImage(images, imagePosition)) {
    return /*#__PURE__*/React.createElement(ImageCard, {
      className: finalClassName
    }, /*#__PURE__*/React.createElement(ImageCard.Image, {
      src: images[0],
      background: true
    }, imageCardComponents));
  }
  var imageComponent = null;
  if (shouldRenderSingleImage(images, imagePosition)) {
    imageComponent = /*#__PURE__*/React.createElement(ImageCard.Image, {
      src: images[0]
    });
    if (!_isEmpty(mainClickthroughInteraction)) {
      imageComponent = /*#__PURE__*/React.createElement(WebsiteComponentInteraction, {
        className: "announcement-image-link",
        interaction: _objectSpread(_objectSpread({}, mainClickthroughInteraction), {}, {
          displayType: INTERACTION_DISPLAY_TYPE_ICON
        }),
        event: {
          category: ANNOUNCEMENT_EVENT_CATEGORY,
          action: ANNOUNCEMENT_MODAL_BUTTON_CLICK_ACTION,
          label: _get(mainClickthroughInteraction, INTERACTION_LABEL),
          value: _get(mainClickthroughInteraction, INTERACTION_URL)
        }
      }, imageComponent);
    }
  }
  if (shouldRenderImageCarousel(images)) {
    imageComponent = /*#__PURE__*/React.createElement(ImageCard.ImageCarousel, {
      images: images
    });
  }
  var firstComponent = FIRST_POSITIONS.includes(imagePosition) ? imageComponent : imageCardComponents;
  var secondComponent = !FIRST_POSITIONS.includes(imagePosition) ? imageComponent : imageCardComponents;
  return /*#__PURE__*/React.createElement(ImageCard, {
    className: finalClassName
  }, firstComponent, secondComponent);
}
Announcement.defaultProps = defaultProps;